import * as React from 'react'
import {useEffect} from "react";
export default function Footnote({children}){

    const id = children.data && children.data.replace('[','').replace(']','');

    useEffect(() => {

    }, []);

    const handleClick = (e) => {
        const elements = document.querySelectorAll(`.scrolled`);
        elements.forEach(element => {
            element.classList.remove('scrolled');
        });
        e.preventDefault();

        const element = document.getElementById(e.target.hash.replace('#',''));
        element.scrollIntoView({behavior: 'smooth'});
        element.classList.add('scrolled');
        window.history.replaceState(undefined, undefined,  e.target.hash);
    }

    return (
        <sup id={'cite_ref-'+id} className={'footnote'}>
            <a href={'#cite_note-' + id} title={'Przypis '+id} onClick={handleClick} style={{ textDecoration: 'none' }}>{children.data}</a>
        </sup>
    )
}